import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateCompanyPeriodsEntity } from '../../domain/entities/UpdateCompanyPeriodsEntity'
import { CompanyOrderPeriodModel } from './CompanyOrderPeriodModel'

export class UpdateCompanyPeriodsModel extends UpdateCompanyPeriodsEntity {
 declare periods?: CompanyOrderPeriodModel[]

  constructor(dataDto: UpdateCompanyPeriodsEntity) {
    super()
    mapEntityProperties<UpdateCompanyPeriodsModel>(this, dataDto, {
      map: {
        periods: dataDto.periods?.map((period) => new CompanyOrderPeriodModel(period))
      }
    })
  }
}